import { OnInit, EventEmitter } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
var RadioInputGroupComponent = /** @class */ (function () {
    function RadioInputGroupComponent() {
        this._value = '';
        this.inline = false;
        this.optionChanged = new EventEmitter();
        this.propagateChange = function (_) { };
    }
    Object.defineProperty(RadioInputGroupComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var option = _a[_i];
                if (val && (option.id == val || option.id == val.id))
                    option.selected = true;
            }
            this._value = val;
            this.propagateChange(this._value);
        },
        enumerable: true,
        configurable: true
    });
    RadioInputGroupComponent.prototype.ngOnInit = function () {
    };
    RadioInputGroupComponent.prototype.trackByRadioId = function (radioBttn) {
        return radioBttn.id;
    };
    RadioInputGroupComponent.prototype.onRadioChange = function (event) {
        var activeOption = null;
        this.options.forEach(function (option) {
            if (!event[option.id]) {
                option['selected'] = false;
            }
            else {
                activeOption = option.id;
                option['selected'] = true;
            }
        });
        this.optionChanged.emit(activeOption);
    };
    RadioInputGroupComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    RadioInputGroupComponent.prototype.registerOnTouched = function (fn) { };
    RadioInputGroupComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    return RadioInputGroupComponent;
}());
export { RadioInputGroupComponent };
